'use strict';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _range2 = _interopRequireDefault(require("lodash/range"));
(function () {
  Entry.wizwingcontrollerlite = new (/*#__PURE__*/function () {
    function wizwingcontrollerlite() {
      (0, _classCallCheck2["default"])(this, wizwingcontrollerlite);
      this.id = '69.1';
      this.name = 'wizwingcontrollerlite';
      this.url = 'http://www.wizwing.co.kr/';
      this.imageName = 'wizwingcontrollerlite.png';
      this.title = {
        ko: '위즈윙 코딩드론 R4 조종기',
        en: 'wizwing coding drone R4 controller'
      };
      this.duration = 32;
      this.blockMenuBlocks = ['Wizwing_Drone_Controller_connect', 'Wizwing_Drone_Controller_takeoff', 'Wizwing_Drone_Controller_land', 'Wizwing_Drone_Controller_throttle', 'Wizwing_Drone_Controller_elevator', 'Wizwing_Drone_Controller_aileron', 'Wizwing_Drone_Controller_rudder', 'Wizwing_Drone_Controller_funled', 'Wizwing_Drone_Controller_flip', 'Wizwing_Drone_Controller_speed', 'Wizwing_Drone_Controller_emergency', 'Wizwing_Drone_Controller_opt', 'Wizwing_Drone_Controller_gyroreset', 'Wizwing_Drone_Controller_headless', 'Wizwing_Drone_Controller_diagonal', 'Wizwing_Drone_Controller_circularflight', 'Wizwing_Drone_Controller_photoflight'];
      this.portData = {
        baudRate: 9600,
        duration: 32,
        dataBits: 8,
        parity: 'none',
        stopBits: 1,
        bufferSize: 512,
        constantServing: false
      };
      this.readablePorts = [];
      this.remainValue = null;
      this.setZero();
    }
    return (0, _createClass2["default"])(wizwingcontrollerlite, [{
      key: "setZero",
      value: function setZero() {
        this.port = new Array(14).fill(0);
        this.digitalValue = new Array(14).fill(0);
        this.remoteDigitalValue = new Array(14).fill(0);
        this.analogValue = new Array(6).fill(0);
        this.readablePorts = (0, _range2["default"])(0, 19);
        if (Entry.hwLite && Entry.hwLite.serial) {
          Entry.hwLite.serial.update();
        }
      }
    }, {
      key: "handleLocalData",
      value: function handleLocalData(data) {
        for (var i = 0; i < 32; i++) {
          var chunk = void 0;
          if (!this.remainValue) {
            chunk = data[i];
          } else {
            chunk = this.remainValue;
            i--;
          }
          if (chunk === SOME_EXPECTED_RESPONSE) {
            console.log('Takeoff command acknowledged by drone.');
          } else {
            console.log('Unexpected response from drone:', chunk);
          }
          if (chunk >> 7) {
            if (chunk >> 6 & 1) {
              var nextChunk = data[i + 1];
              if (!nextChunk && nextChunk !== 0) {
                this.remainValue = chunk;
              } else {
                this.remainValue = null;
                var port = chunk >> 3 & 7;
                this.analogValue[port] = ((chunk & 7) << 7) + (nextChunk & 127);
              }
              i++;
            } else {
              var _port = chunk >> 2 & 15;
              this.digitalValue[_port] = chunk & 1;
            }
          }
        }
      }
    }, {
      key: "requestLocalData",
      value: function requestLocalData() {
        var queryString = [];
        var readablePorts = this.readablePorts;
        var commandStr = Entry.hw.sendQueue['COMMAND'];
        if (commandStr) {
          for (var i = 0; i < commandStr.length; i++) {
            queryString.push(commandStr.charCodeAt(i));
          }
          delete Entry.hw.sendQueue['COMMAND'];
        }
        if (readablePorts) {
          for (var _i in readablePorts) {
            var query = (5 << 5) + (readablePorts[_i] << 1);
            queryString.push(query);
          }
        }
        var readablePortsValues = readablePorts && Object.values(readablePorts) || [];
        for (var port = 0; port < 14; port++) {
          if (readablePortsValues.indexOf(port) > -1) {
            continue;
          }
          var value = this.remoteDigitalValue[port];
          if (value === 255 || value === 0) {
            var _query = (7 << 5) + (port << 1) + (value == 255 ? 1 : 0);
            queryString.push(_query);
          } else if (value > 0 && value < 255) {
            var _query2 = (6 << 5) + (port << 1) + (value >> 7);
            queryString.push(_query2);
            _query2 = value & 127;
            queryString.push(_query2);
          }
        }
        return queryString;
      }
    }, {
      key: "addReadablePort",
      value: function addReadablePort(port) {
        var idx = Entry.ArduinoLite.readablePorts.indexOf(port);
        if (idx === -1) {
          Entry.ArduinoLite.readablePorts.push(port);
        }
      }
    }, {
      key: "removeReadablePort",
      value: function removeReadablePort(port) {
        var idx = Entry.ArduinoLite.readablePorts.indexOf(port);
        if (idx >= 0) {
          Entry.ArduinoLite.readablePorts.splice(idx, 1);
        }
      }
    }, {
      key: "setLanguage",
      value: function setLanguage() {
        return {
          ko: {
            Blocks: {
              Wizwing_Drone_Controller_flip_f: '앞으로  ',
              Wizwing_Drone_Controller_flip_b: '뒤로  ',
              Wizwing_Drone_Controller_flip_l: '왼쪽으로  ',
              Wizwing_Drone_Controller_flip_r: '오른쪽으로  '
            },
            template: {
              Wizwing_Drone_Controller_connect: '페어링(바인딩)  ',
              Wizwing_Drone_Controller_takeoff: '자동이륙  ',
              Wizwing_Drone_Controller_land: '자동착륙  ',
              Wizwing_Drone_Controller_throttle: '스로틀 %1만큼 %2ms  ',
              Wizwing_Drone_Controller_elevator: '엘리베이터 %1만큼 %2ms  ',
              Wizwing_Drone_Controller_aileron: '에일러론 %1만큼 %2ms  ',
              Wizwing_Drone_Controller_rudder: '러더 %1만큼 %2 ms  ',
              Wizwing_Drone_Controller_funled: '7색 LED 색 변경  ',
              Wizwing_Drone_Controller_flip: '360도회전 %1  ',
              Wizwing_Drone_Controller_speed: '속도조절 %1 단 ',
              Wizwing_Drone_Controller_emergency: '모터긴급정지  ',
              Wizwing_Drone_Controller_opt: '비전센서 on/off  ',
              Wizwing_Drone_Controller_gyroreset: '자이로 초기화  ',
              Wizwing_Drone_Controller_headless: '헤드리스 모드 on/off  ',
              Wizwing_Drone_Controller_diagonal: '엘리베이터%1 에일러론%2 %3ms   ',
              Wizwing_Drone_Controller_circularflight: '엘리베이터%1 러더%2 %3ms   ',
              Wizwing_Drone_Controller_photoflight: '에일러론%1 러더%2 %3ms   '
            },
            Device: {
              Wizwing_Drone_Controller: '위즈윙 코딩드론 R4 조종기'
            },
            Menus: {
              Wizwing_Drone_Controller: '위즈윙 코딩드론 R4 조종기'
            },
            Helper: {
              Wizwing_Drone_Controller_connect: '페어링(바인딩)  ',
              Wizwing_Drone_Controller_takeoff: '자동 이륙  ',
              Wizwing_Drone_Controller_land: '자동 착륙  ',
              Wizwing_Drone_Controller_throttle: '드론이 상승/ 하강합니다  ',
              Wizwing_Drone_Controller_elevator: '드론이 앞/뒤로 이동합니다  ',
              Wizwing_Drone_Controller_aileron: '드론이 좌/우로 이동합니다  ',
              Wizwing_Drone_Controller_rudder: '드론이 좌/우로 회전합니다.  ',
              Wizwing_Drone_Controller_funled: '7색 LED 색 변경  ',
              Wizwing_Drone_Controller_flip: '360도회전 %1   ',
              Wizwing_Drone_Controller_speed: '속도 %1 단 ',
              Wizwing_Drone_Controller_emergency: '모터긴급정지  ',
              Wizwing_Drone_Controller_opt: '비전센서 on/off  ',
              Wizwing_Drone_Controller_gyroreset: '자이로 초기화  ',
              Wizwing_Drone_Controller_headless: '헤드리스 모드  ',
              Wizwing_Drone_Controller_diagonal: '대각선으로 이동  ',
              Wizwing_Drone_Controller_circularflight: '선회비행  ',
              Wizwing_Drone_Controller_photoflight: '촬영비행  '
            }
          },
          en: {
            template: {
              Wizwing_Drone_Controller_connect: 'Fairing(Binding)',
              Wizwing_Drone_Controller_takeoff: 'Auto Takeoff ',
              Wizwing_Drone_Controller_land: 'Auto Landing ',
              Wizwing_Drone_Controller_throttle: 'thottle %1 time %2ms  ',
              Wizwing_Drone_Controller_elevator: 'elevator %1 time %2ms  ',
              Wizwing_Drone_Controller_aileron: 'aileron %1 time %2ms  ',
              Wizwing_Drone_Controller_rudder: 'rudder %1 time %2ms  ',
              Wizwing_Drone_Controller_funled: '7-color LED color change  ',
              Wizwing_Drone_Controller_flip: '%1  360 flip  ',
              Wizwing_Drone_Controller_speed: 'Speed adjustment %1',
              Wizwing_Drone_Controller_emergency: 'Emergency Stop ',
              Wizwing_Drone_Controller_opt: 'vision sensor on/off  ',
              Wizwing_Drone_Controller_gyroreset: 'Gyro Reset ',
              Wizwing_Drone_Controller_headless: 'Headless Mode ',
              Wizwing_Drone_Controller_diagonal: 'diagonal Mode ',
              Wizwing_Drone_Controller_circularflight: 'circularflight Mode ',
              Wizwing_Drone_Controller_photoflight: 'photoflight Mode '
            },
            Device: {
              Wizwing_Drone_Controller: 'wizwingdroncontroller'
            },
            Menus: {
              Wizwing_Drone_Controller: 'WizwingDronController'
            }
          }
        };
      }
    }, {
      key: "initializeBlocks",
      value: function initializeBlocks() {
        var _this = this;
        Entry.hwLite.connect().then(function () {
          if (!Entry.hwLite.serial) {
            console.error('Serial object is not defined. Please check the connection.');
            return;
          }
          Entry.getMainGenerator().getBlocks = _this.getBlocks.bind(_this);
          Entry.addEventListener('blockCompleted', function () {
            Entry.getMainGenerator().nextBlock();
          });
        })["catch"](function (error) {
          console.error('Failed to connect to hardware:', error);
        });
      }
    }, {
      key: "getBlocks",
      value: function getBlocks() {
        return {
          Wizwing_Drone_Controller_connect: {
            color: EntryStatic.colorSet.block["default"].HARDWARE,
            outerLine: EntryStatic.colorSet.block.darken.HARDWARE,
            skeleton: 'basic',
            params: [],
            def: {
              params: [],
              type: 'Wizwing_Drone_Controller_connect'
            },
            "class": 'wizwing',
            isNotFor: ['wizwingcontrollerlite'],
            func: function func(sprite, script) {
              var command = 'mapping_start';
              var commandBuffer = Buffer.from(encodeURIComponent(command) + '\r', 'utf8');
              if (Entry.hwLite && Entry.hwLite.serial && Entry.hwLite.serial.writer) {
                Entry.hwLite.serial.sendAsyncWithThrottle(commandBuffer, false);
                console.log('Command sent using sendAsyncWithThrottle:', command);
                return new Promise(function (resolve) {
                  setTimeout(function () {
                    resolve(script.callReturn());
                  }, 1100);
                });
              } else {
                console.log('Serial writer not found.');
              }
              return script.callReturn();
            }
          },
          Wizwing_Drone_Controller_takeoff: {
            color: EntryStatic.colorSet.block["default"].HARDWARE,
            outerLine: EntryStatic.colorSet.block.darken.HARDWARE,
            skeleton: 'basic',
            params: [],
            def: {
              params: [],
              type: 'Wizwing_Drone_Controller_takeoff'
            },
            "class": 'wizwing',
            isNotFor: ['wizwingcontrollerlite'],
            func: function func(sprite, script) {
              var command = 'takeoff';
              var commandBuffer = Buffer.from(encodeURIComponent(command) + '\r', 'utf8');
              console.log("Sending command: ".concat(command));
              if (Entry.hwLite && Entry.hwLite.serial && Entry.hwLite.serial.writer) {
                Entry.hwLite.serial.sendAsyncWithThrottle(commandBuffer, false);
                console.log('Command sent using sendAsyncWithThrottle:', command);
                return new Promise(function (resolve) {
                  setTimeout(function () {
                    resolve(script.callReturn());
                  }, 4000);
                });
              } else {
                console.log('Serial writer not found.');
              }
              return script.callReturn();
            }
          },
          Wizwing_Drone_Controller_land: {
            color: EntryStatic.colorSet.block["default"].HARDWARE,
            outerLine: EntryStatic.colorSet.block.darken.HARDWARE,
            skeleton: 'basic',
            fontColor: '#fff',
            params: [],
            def: {
              params: [],
              type: 'Wizwing_Drone_Controller_land'
            },
            "class": 'wizwing',
            isNotFor: ['wizwingcontrollerlite'],
            func: function func(sprite, script) {
              var command = 'land';
              var commandBuffer = Buffer.from(encodeURIComponent(command) + '\r', 'utf8');
              console.log("Sending command: ".concat(command));
              if (Entry.hwLite && Entry.hwLite.serial && Entry.hwLite.serial.writer) {
                Entry.hwLite.serial.sendAsyncWithThrottle(commandBuffer, false);
                console.log('Command sent using sendAsyncWithThrottle:', command);
                return new Promise(function (resolve) {
                  setTimeout(function () {
                    resolve(script.callReturn());
                  }, 3000);
                });
              } else {
                console.log('Serial writer not found.');
              }
              return script.callReturn();
            }
          },
          Wizwing_Drone_Controller_throttle: {
            color: EntryStatic.colorSet.block["default"].HARDWARE,
            outerLine: EntryStatic.colorSet.block.darken.HARDWARE,
            skeleton: 'basic',
            fontColor: '#fff',
            statements: [],
            params: [{
              type: 'Block',
              accept: 'string'
            }, {
              type: 'Block',
              accept: 'string'
            }],
            def: {
              params: [null, null],
              type: 'Wizwing_Drone_Controller_throttle'
            },
            paramsKeyMap: {
              STICK: 0,
              TIME: 1
            },
            "class": 'wizwing',
            isNotFor: ['wizwingcontrollerlite'],
            func: function func(sprite, script) {
              var stick = script.getNumberValue('STICK', script) * 5;
              var time = script.getNumberValue('TIME', script);
              if (stick > 500) {
                stick = 500;
              } else if (stick < -500) {
                stick = -500;
              }
              if (stick >= 0) {
                var command1 = "up ".concat(stick, " ").concat(time, "\r");
                console.log('Constructed command:', command1);
                var commandBuffer = Buffer.from(command1, 'utf8');
                if (Entry.hwLite && Entry.hwLite.serial && Entry.hwLite.serial.writer) {
                  Entry.hwLite.serial.sendAsyncWithThrottle(commandBuffer, false);
                  console.log('Command sent using sendAsyncWithThrottle:', command1);
                  return new Promise(function (resolve) {
                    setTimeout(function () {
                      resolve(script.callReturn());
                    }, time + 1100);
                  });
                } else {
                  console.log('Serial writer not found.');
                }
              } else {
                stick = stick * -1;
                var command2 = "down ".concat(stick, " ").concat(time, "\r");
                console.log('Constructed command:', command2);
                var _commandBuffer = Buffer.from(command2, 'utf8');
                if (Entry.hwLite && Entry.hwLite.serial && Entry.hwLite.serial.writer) {
                  Entry.hwLite.serial.sendAsyncWithThrottle(_commandBuffer, false);
                  console.log('Command sent using sendAsyncWithThrottle:', command2);
                  return new Promise(function (resolve) {
                    setTimeout(function () {
                      resolve(script.callReturn());
                    }, time + 1100);
                  });
                } else {
                  console.log('Serial writer not found.');
                }
              }
              return script.callReturn();
            }
          },
          Wizwing_Drone_Controller_elevator: {
            color: EntryStatic.colorSet.block["default"].HARDWARE,
            outerLine: EntryStatic.colorSet.block.darken.HARDWARE,
            skeleton: 'basic',
            fontColor: '#fff',
            statements: [],
            params: [{
              type: 'Block',
              accept: 'string'
            }, {
              type: 'Block',
              accept: 'string'
            }],
            def: {
              params: [null, null],
              type: 'Wizwing_Drone_Controller_elevator'
            },
            paramsKeyMap: {
              STICK: 0,
              TIME: 1
            },
            "class": 'wizwing',
            isNotFor: ['wizwingcontrollerlite'],
            func: function func(sprite, script) {
              var stick = script.getNumberValue('STICK', script) * 5;
              var time = script.getNumberValue('TIME', script);
              if (stick > 500) {
                stick = 500;
              } else if (stick < -500) {
                stick = -500;
              }
              if (stick >= 0) {
                var command1 = "forward ".concat(stick, " ").concat(time, "\r");
                console.log('Constructed command:', command1);
                var commandBuffer = Buffer.from(command1, 'utf8');
                if (Entry.hwLite && Entry.hwLite.serial && Entry.hwLite.serial.writer) {
                  Entry.hwLite.serial.sendAsyncWithThrottle(commandBuffer, false);
                  console.log('Command sent using sendAsyncWithThrottle:', command1);
                  return new Promise(function (resolve) {
                    setTimeout(function () {
                      resolve(script.callReturn());
                    }, time + 1100);
                  });
                } else {
                  console.log('Serial writer not found.');
                }
              } else {
                stick = stick * -1;
                var command2 = "back ".concat(stick, " ").concat(time, "\r");
                console.log('Constructed command:', command2);
                var _commandBuffer2 = Buffer.from(command2, 'utf8');
                if (Entry.hwLite && Entry.hwLite.serial && Entry.hwLite.serial.writer) {
                  Entry.hwLite.serial.sendAsyncWithThrottle(_commandBuffer2, false);
                  console.log('Command sent using sendAsyncWithThrottle:', command2);
                  return new Promise(function (resolve) {
                    setTimeout(function () {
                      resolve(script.callReturn());
                    }, time + 1100);
                  });
                } else {
                  console.log('Serial writer not found.');
                }
              }
              return script.callReturn();
            }
          },
          Wizwing_Drone_Controller_aileron: {
            color: EntryStatic.colorSet.block["default"].HARDWARE,
            outerLine: EntryStatic.colorSet.block.darken.HARDWARE,
            skeleton: 'basic',
            fontColor: '#fff',
            statements: [],
            params: [{
              type: 'Block',
              accept: 'string'
            }, {
              type: 'Block',
              accept: 'string'
            }],
            def: {
              params: [null, null],
              type: 'Wizwing_Drone_Controller_aileron'
            },
            paramsKeyMap: {
              STICK: 0,
              TIME: 1
            },
            "class": 'wizwing',
            isNotFor: ['wizwingcontrollerlite'],
            func: function func(sprite, script) {
              var stick = script.getNumberValue('STICK', script) * 5;
              var time = script.getNumberValue('TIME', script);
              if (stick > 500) {
                stick = 500;
              } else if (stick < -500) {
                stick = -500;
              }
              if (stick >= 0) {
                var command1 = "right ".concat(stick, " ").concat(time, "\r");
                console.log('Constructed command:', command1);
                var commandBuffer = Buffer.from(command1, 'utf8');
                if (Entry.hwLite && Entry.hwLite.serial && Entry.hwLite.serial.writer) {
                  Entry.hwLite.serial.sendAsyncWithThrottle(commandBuffer, false);
                  console.log('Command sent using sendAsyncWithThrottle:', command1);
                  return new Promise(function (resolve) {
                    setTimeout(function () {
                      resolve(script.callReturn());
                    }, time + 1100);
                  });
                } else {
                  console.log('Serial writer not found.');
                }
              } else {
                stick = stick * -1;
                var command2 = "left ".concat(stick, " ").concat(time, "\r");
                console.log('Constructed command:', command2);
                var _commandBuffer3 = Buffer.from(command2, 'utf8');
                if (Entry.hwLite && Entry.hwLite.serial && Entry.hwLite.serial.writer) {
                  Entry.hwLite.serial.sendAsyncWithThrottle(_commandBuffer3, false);
                  console.log('Command sent using sendAsyncWithThrottle:', command2);
                  return new Promise(function (resolve) {
                    setTimeout(function () {
                      resolve(script.callReturn());
                    }, time + 1100);
                  });
                } else {
                  console.log('Serial writer not found.');
                }
              }
              return script.callReturn();
            }
          },
          Wizwing_Drone_Controller_rudder: {
            color: EntryStatic.colorSet.block["default"].HARDWARE,
            outerLine: EntryStatic.colorSet.block.darken.HARDWARE,
            skeleton: 'basic',
            fontColor: '#fff',
            statements: [],
            params: [{
              type: 'Block',
              accept: 'string'
            }, {
              type: 'Block',
              accept: 'string'
            }],
            def: {
              params: [null, null],
              type: 'Wizwing_Drone_Controller_rudder'
            },
            paramsKeyMap: {
              STICK: 0,
              TIME: 1
            },
            "class": 'wizwing',
            isNotFor: ['wizwingcontrollerlite'],
            func: function func(sprite, script) {
              var stick = script.getNumberValue('STICK', script) * 5;
              var time = script.getNumberValue('TIME', script);
              if (stick > 500) {
                stick = 500;
              } else if (stick < -500) {
                stick = -500;
              }
              if (stick >= 0) {
                var command1 = "cw ".concat(stick, " ").concat(time, "\r");
                console.log('Constructed command:', command1);
                var commandBuffer = Buffer.from(command1, 'utf8');
                if (Entry.hwLite && Entry.hwLite.serial && Entry.hwLite.serial.writer) {
                  Entry.hwLite.serial.sendAsyncWithThrottle(commandBuffer, false);
                  console.log('Command sent using sendAsyncWithThrottle:', command1);
                  return new Promise(function (resolve) {
                    setTimeout(function () {
                      resolve(script.callReturn());
                    }, time + 1100);
                  });
                } else {
                  console.log('Serial writer not found.');
                }
              } else {
                stick = stick * -1;
                var command2 = "ccw ".concat(stick, " ").concat(time, "\r");
                console.log('Constructed command:', command2);
                var _commandBuffer4 = Buffer.from(command2, 'utf8');
                if (Entry.hwLite && Entry.hwLite.serial && Entry.hwLite.serial.writer) {
                  Entry.hwLite.serial.sendAsyncWithThrottle(_commandBuffer4, false);
                  console.log('Command sent using sendAsyncWithThrottle:', command2);
                  return new Promise(function (resolve) {
                    setTimeout(function () {
                      resolve(script.callReturn());
                    }, time + 1100);
                  });
                } else {
                  console.log('Serial writer not found.');
                }
              }
              return script.callReturn();
            }
          },
          Wizwing_Drone_Controller_funled: {
            color: EntryStatic.colorSet.block["default"].HARDWARE,
            outerLine: EntryStatic.colorSet.block.darken.HARDWARE,
            skeleton: 'basic',
            fontColor: '#fff',
            params: [],
            def: {
              params: [],
              type: 'Wizwing_Drone_Controller_funled'
            },
            "class": 'wizwing',
            isNotFor: ['wizwingcontrollerlite'],
            func: function func(sprite, script) {
              var command = 'funled';
              var commandBuffer = Buffer.from(encodeURIComponent(command) + '\r', 'utf8');
              if (Entry.hwLite && Entry.hwLite.serial && Entry.hwLite.serial.writer) {
                Entry.hwLite.serial.sendAsyncWithThrottle(commandBuffer, false);
                console.log('Command sent using sendAsyncWithThrottle:', command);
                return new Promise(function (resolve) {
                  setTimeout(function () {
                    resolve(script.callReturn());
                  }, 1100);
                });
              } else {
                console.log('Serial writer not found.');
              }
              return script.callReturn();
            }
          },
          Wizwing_Drone_Controller_flip: {
            color: EntryStatic.colorSet.block["default"].HARDWARE,
            outerLine: EntryStatic.colorSet.block.darken.HARDWARE,
            skeleton: 'basic',
            fontColor: '#fff',
            params: [{
              type: 'Dropdown',
              options: [[Lang.Blocks.Wizwing_Drone_Controller_flip_f, 'f'], [Lang.Blocks.Wizwing_Drone_Controller_flip_b, 'b'], [Lang.Blocks.Wizwing_Drone_Controller_flip_l, 'l'], [Lang.Blocks.Wizwing_Drone_Controller_flip_r, 'r']],
              value: 'f',
              fontSize: 11,
              bgColor: EntryStatic.colorSet.block.darken.HARDWARE,
              arrowColor: EntryStatic.colorSet.arrow["default"].HARDWARE
            }],
            def: {
              params: [null],
              type: 'Wizwing_Drone_Controller_flip'
            },
            paramsKeyMap: {
              DIRECTION: 0
            },
            "class": 'wizwing',
            isNotFor: ['wizwingcontrollerlite'],
            func: function func(sprite, script) {
              var direction = script.getField('DIRECTION');
              var command = "flip ".concat(direction, "\r");
              var commandBuffer = Buffer.from(command, 'utf8');
              if (Entry.hwLite && Entry.hwLite.serial && Entry.hwLite.serial.writer) {
                Entry.hwLite.serial.sendAsyncWithThrottle(commandBuffer, false);
                console.log('Command sent using sendAsyncWithThrottle:', command);
                return new Promise(function (resolve) {
                  setTimeout(function () {
                    resolve(script.callReturn());
                  }, 4100);
                });
              } else {
                console.log('Serial writer not found.');
              }
              return script.callReturn();
            }
          },
          Wizwing_Drone_Controller_speed: {
            color: EntryStatic.colorSet.block["default"].HARDWARE,
            outerLine: EntryStatic.colorSet.block.darken.HARDWARE,
            skeleton: 'basic',
            fontColor: '#fff',
            params: [{
              type: 'Dropdown',
              options: [['1', '1'], ['2', '2'], ['3', '3']],
              value: '1',
              fontSize: 11,
              bgColor: EntryStatic.colorSet.block.darken.HARDWARE,
              arrowColor: EntryStatic.colorSet.arrow["default"].HARDWARE
            }],
            def: {
              params: [null],
              type: 'Wizwing_Drone_Controller_speed'
            },
            paramsKeyMap: {
              DIRECTION: 0
            },
            "class": 'wizwing',
            isNotFor: ['wizwingcontrollerlite'],
            func: function func(sprite, script) {
              var direction = script.getField('DIRECTION');
              var command = "speed ".concat(direction, "\r");
              var commandBuffer = Buffer.from(command, 'utf8');
              if (Entry.hwLite && Entry.hwLite.serial && Entry.hwLite.serial.writer) {
                Entry.hwLite.serial.sendAsyncWithThrottle(commandBuffer, false);
                console.log('Command sent using sendAsyncWithThrottle:', command);
                return new Promise(function (resolve) {
                  setTimeout(function () {
                    resolve(script.callReturn());
                  }, 1100);
                });
              } else {
                console.log('Serial writer not found.');
              }
              return script.callReturn();
            }
          },
          Wizwing_Drone_Controller_emergency: {
            color: EntryStatic.colorSet.block["default"].HARDWARE,
            outerLine: EntryStatic.colorSet.block.darken.HARDWARE,
            skeleton: 'basic',
            fontColor: '#fff',
            params: [],
            def: {
              params: [],
              type: 'Wizwing_Drone_Controller_emergency'
            },
            "class": 'wizwing',
            isNotFor: ['wizwingcontrollerlite'],
            func: function func(sprite, script) {
              var command = 'emergency';
              var commandBuffer = Buffer.from(encodeURIComponent(command) + '\r', 'utf8');
              if (Entry.hwLite && Entry.hwLite.serial && Entry.hwLite.serial.writer) {
                Entry.hwLite.serial.sendAsyncWithThrottle(commandBuffer, false);
                console.log('Command sent using sendAsyncWithThrottle:', command);
                return new Promise(function (resolve) {
                  setTimeout(function () {
                    resolve(script.callReturn());
                  }, 1100);
                });
              } else {
                console.log('Serial writer not found.');
              }
              return script.callReturn();
            }
          },
          Wizwing_Drone_Controller_opt: {
            color: EntryStatic.colorSet.block["default"].HARDWARE,
            outerLine: EntryStatic.colorSet.block.darken.HARDWARE,
            skeleton: 'basic',
            params: [],
            def: {
              params: [],
              type: 'Wizwing_Drone_Controller_opt'
            },
            "class": 'wizwing',
            isNotFor: ['wizwingcontrollerlite'],
            func: function func(sprite, script) {
              var command = 'opt';
              var commandBuffer = Buffer.from(encodeURIComponent(command) + '\r', 'utf8');
              if (Entry.hwLite && Entry.hwLite.serial && Entry.hwLite.serial.writer) {
                Entry.hwLite.serial.sendAsyncWithThrottle(commandBuffer, false);
                console.log('Command sent using sendAsyncWithThrottle:', command);
                return new Promise(function (resolve) {
                  setTimeout(function () {
                    resolve(script.callReturn());
                  }, 1100);
                });
              } else {
                console.log('Serial writer not found.');
              }
              return script.callReturn();
            }
          },
          Wizwing_Drone_Controller_gyroreset: {
            color: EntryStatic.colorSet.block["default"].HARDWARE,
            outerLine: EntryStatic.colorSet.block.darken.HARDWARE,
            skeleton: 'basic',
            params: [],
            def: {
              params: [],
              type: 'Wizwing_Drone_Controller_gyroreset'
            },
            "class": 'wizwing',
            isNotFor: ['wizwingcontrollerlite'],
            func: function func(sprite, script) {
              var command = 'gyroreset';
              var commandBuffer = Buffer.from(encodeURIComponent(command) + '\r', 'utf8');
              if (Entry.hwLite && Entry.hwLite.serial && Entry.hwLite.serial.writer) {
                Entry.hwLite.serial.sendAsyncWithThrottle(commandBuffer, false);
                console.log('Command sent using sendAsyncWithThrottle:', command);
                return new Promise(function (resolve) {
                  setTimeout(function () {
                    resolve(script.callReturn());
                  }, 1100);
                });
              } else {
                console.log('Serial writer not found.');
              }
              return script.callReturn();
            }
          },
          Wizwing_Drone_Controller_headless: {
            color: EntryStatic.colorSet.block["default"].HARDWARE,
            outerLine: EntryStatic.colorSet.block.darken.HARDWARE,
            skeleton: 'basic',
            fontColor: '#fff',
            params: [],
            def: {
              params: [null],
              type: 'Wizwing_Drone_Controller_headless'
            },
            "class": 'wizwing',
            isNotFor: ['wizwingcontrollerlite'],
            func: function func(sprite, script) {
              var command = 'headless';
              var commandBuffer = Buffer.from(encodeURIComponent(command) + '\r', 'utf8');
              if (Entry.hwLite && Entry.hwLite.serial && Entry.hwLite.serial.writer) {
                Entry.hwLite.serial.sendAsyncWithThrottle(commandBuffer, false);
                console.log('Command sent using sendAsyncWithThrottle:', command);
                return new Promise(function (resolve) {
                  setTimeout(function () {
                    resolve(script.callReturn());
                  }, 1100);
                });
              } else {
                console.log('Serial writer not found.');
              }
              return script.callReturn();
            }
          },
          Wizwing_Drone_Controller_diagonal: {
            color: EntryStatic.colorSet.block["default"].HARDWARE,
            outerLine: EntryStatic.colorSet.block.darken.HARDWARE,
            skeleton: 'basic',
            fontColor: '#fff',
            statements: [],
            params: [{
              type: 'Block',
              accept: 'string'
            }, {
              type: 'Block',
              accept: 'string'
            }, {
              type: 'Block',
              accept: 'string'
            }],
            def: {
              params: [null, null, null],
              type: 'Wizwing_Drone_Controller_diagonal'
            },
            paramsKeyMap: {
              STICK1: 0,
              STICK2: 1,
              TIME: 2
            },
            "class": 'wizwing',
            isNotFor: ['wizwingcontrollerlite'],
            func: function func(sprite, script) {
              var stick1 = script.getNumberValue('STICK1', script) * 5;
              var stick2 = script.getNumberValue('STICK2', script) * 5;
              var time = script.getNumberValue('TIME', script);
              if (stick1 > 500) {
                stick1 = 500;
              } else if (stick1 < -500) {
                stick1 = -500;
              }
              if (stick2 > 500) {
                stick2 = 500;
              } else if (stick2 < -500) {
                stick2 = -500;
              }
              if (stick1 >= 0 && stick2 >= 0) {
                var command1 = "forward ".concat(stick1, " ").concat(time, "\r");
                console.log('Constructed command:', command1);
                var commandBuffer1 = Buffer.from(command1, 'utf8');
                var command11 = "right ".concat(stick2, " ").concat(time, "\r");
                console.log('Constructed command:', command11);
                var commandBuffer11 = Buffer.from(command11, 'utf8');
                if (Entry.hwLite && Entry.hwLite.serial && Entry.hwLite.serial.writer) {
                  Entry.hwLite.serial.sendAsyncWithThrottle(commandBuffer1, false);
                  console.log('Command sent using sendAsyncWithThrottle:', command1);
                  Entry.hwLite.serial.sendAsyncWithThrottle(commandBuffer11, false);
                  console.log('Command sent using sendAsyncWithThrottle:', command11);
                  return new Promise(function (resolve) {
                    setTimeout(function () {
                      resolve(script.callReturn());
                    }, time + 1100);
                  });
                } else {
                  console.log('Serial writer not found.');
                }
              } else if (stick1 >= 0 && stick2 < 0) {
                stick2 = stick2 * -1;
                var _command = "forward ".concat(stick1, " ").concat(time, "\r");
                console.log('Constructed command:', _command);
                var _commandBuffer5 = Buffer.from(_command, 'utf8');
                var _command2 = "left ".concat(stick2, " ").concat(time, "\r");
                console.log('Constructed command:', _command2);
                var _commandBuffer6 = Buffer.from(_command2, 'utf8');
                if (Entry.hwLite && Entry.hwLite.serial && Entry.hwLite.serial.writer) {
                  Entry.hwLite.serial.sendAsyncWithThrottle(_commandBuffer5, false);
                  console.log('Command sent using sendAsyncWithThrottle:', _command);
                  Entry.hwLite.serial.sendAsyncWithThrottle(_commandBuffer6, false);
                  console.log('Command sent using sendAsyncWithThrottle:', _command2);
                  return new Promise(function (resolve) {
                    setTimeout(function () {
                      resolve(script.callReturn());
                    }, time + 1100);
                  });
                } else {
                  console.log('Serial writer not found.');
                }
              } else if (stick1 < 0 && stick2 >= 0) {
                stick1 = stick1 * -1;
                var _command3 = "back ".concat(stick1, " ").concat(time, "\r");
                console.log('Constructed command:', _command3);
                var _commandBuffer7 = Buffer.from(_command3, 'utf8');
                var _command4 = "right ".concat(stick2, " ").concat(time, "\r");
                console.log('Constructed command:', _command4);
                var _commandBuffer8 = Buffer.from(_command4, 'utf8');
                if (Entry.hwLite && Entry.hwLite.serial && Entry.hwLite.serial.writer) {
                  Entry.hwLite.serial.sendAsyncWithThrottle(_commandBuffer7, false);
                  console.log('Command sent using sendAsyncWithThrottle:', _command3);
                  Entry.hwLite.serial.sendAsyncWithThrottle(_commandBuffer8, false);
                  console.log('Command sent using sendAsyncWithThrottle:', _command4);
                  return new Promise(function (resolve) {
                    setTimeout(function () {
                      resolve(script.callReturn());
                    }, time + 1100);
                  });
                } else {
                  console.log('Serial writer not found.');
                }
              } else {
                stick1 = stick1 * -1;
                stick2 = stick2 * -1;
                var _command5 = "back ".concat(stick1, " ").concat(time, "\r");
                console.log('Constructed command:', _command5);
                var _commandBuffer9 = Buffer.from(_command5, 'utf8');
                var _command6 = "left ".concat(stick2, " ").concat(time, "\r");
                console.log('Constructed command:', _command6);
                var _commandBuffer0 = Buffer.from(_command6, 'utf8');
                if (Entry.hwLite && Entry.hwLite.serial && Entry.hwLite.serial.writer) {
                  Entry.hwLite.serial.sendAsyncWithThrottle(_commandBuffer9, false);
                  console.log('Command sent using sendAsyncWithThrottle:', _command5);
                  Entry.hwLite.serial.sendAsyncWithThrottle(_commandBuffer0, false);
                  console.log('Command sent using sendAsyncWithThrottle:', _command6);
                  return new Promise(function (resolve) {
                    setTimeout(function () {
                      resolve(script.callReturn());
                    }, time + 1100);
                  });
                } else {
                  console.log('Serial writer not found.');
                }
              }
              return script.callReturn();
            }
          },
          Wizwing_Drone_Controller_circularflight: {
            color: EntryStatic.colorSet.block["default"].HARDWARE,
            outerLine: EntryStatic.colorSet.block.darken.HARDWARE,
            skeleton: 'basic',
            fontColor: '#fff',
            statements: [],
            params: [{
              type: 'Block',
              accept: 'string'
            }, {
              type: 'Block',
              accept: 'string'
            }, {
              type: 'Block',
              accept: 'string'
            }],
            def: {
              params: [null, null, null],
              type: 'Wizwing_Drone_Controller_circularflight'
            },
            paramsKeyMap: {
              STICK1: 0,
              STICK2: 1,
              TIME: 2
            },
            "class": 'wizwing',
            isNotFor: ['wizwingcontrollerlite'],
            func: function func(sprite, script) {
              var stick1 = script.getNumberValue('STICK1', script) * 5;
              var stick2 = script.getNumberValue('STICK2', script) * 5;
              var time = script.getNumberValue('TIME', script);
              if (stick1 > 500) {
                stick1 = 500;
              } else if (stick1 < -500) {
                stick1 = -500;
              }
              if (stick2 > 500) {
                stick2 = 500;
              } else if (stick2 < -500) {
                stick2 = -500;
              }
              if (stick1 >= 0 && stick2 >= 0) {
                var command1 = "forward ".concat(stick1, " ").concat(time, "\r");
                console.log('Constructed command:', command1);
                var commandBuffer1 = Buffer.from(command1, 'utf8');
                var command11 = "cw ".concat(stick2, " ").concat(time, "\r");
                console.log('Constructed command:', command11);
                var commandBuffer11 = Buffer.from(command11, 'utf8');
                if (Entry.hwLite && Entry.hwLite.serial && Entry.hwLite.serial.writer) {
                  Entry.hwLite.serial.sendAsyncWithThrottle(commandBuffer1, false);
                  console.log('Command sent using sendAsyncWithThrottle:', command1);
                  Entry.hwLite.serial.sendAsyncWithThrottle(commandBuffer11, false);
                  console.log('Command sent using sendAsyncWithThrottle:', command11);
                  return new Promise(function (resolve) {
                    setTimeout(function () {
                      resolve(script.callReturn());
                    }, time + 1100);
                  });
                } else {
                  console.log('Serial writer not found.');
                }
              } else if (stick1 >= 0 && stick2 < 0) {
                stick2 = stick2 * -1;
                var _command7 = "forward ".concat(stick1, " ").concat(time, "\r");
                console.log('Constructed command:', _command7);
                var _commandBuffer1 = Buffer.from(_command7, 'utf8');
                var _command8 = "ccw ".concat(stick2, " ").concat(time, "\r");
                console.log('Constructed command:', _command8);
                var _commandBuffer10 = Buffer.from(_command8, 'utf8');
                if (Entry.hwLite && Entry.hwLite.serial && Entry.hwLite.serial.writer) {
                  Entry.hwLite.serial.sendAsyncWithThrottle(_commandBuffer1, false);
                  console.log('Command sent using sendAsyncWithThrottle:', _command7);
                  Entry.hwLite.serial.sendAsyncWithThrottle(_commandBuffer10, false);
                  console.log('Command sent using sendAsyncWithThrottle:', _command8);
                  return new Promise(function (resolve) {
                    setTimeout(function () {
                      resolve(script.callReturn());
                    }, time + 1100);
                  });
                } else {
                  console.log('Serial writer not found.');
                }
              } else if (stick1 < 0 && stick2 >= 0) {
                stick1 = stick1 * -1;
                var _command9 = "back ".concat(stick1, " ").concat(time, "\r");
                console.log('Constructed command:', _command9);
                var _commandBuffer11 = Buffer.from(_command9, 'utf8');
                var _command0 = "cw ".concat(stick2, " ").concat(time, "\r");
                console.log('Constructed command:', _command0);
                var _commandBuffer12 = Buffer.from(_command0, 'utf8');
                if (Entry.hwLite && Entry.hwLite.serial && Entry.hwLite.serial.writer) {
                  Entry.hwLite.serial.sendAsyncWithThrottle(_commandBuffer11, false);
                  console.log('Command sent using sendAsyncWithThrottle:', _command9);
                  Entry.hwLite.serial.sendAsyncWithThrottle(_commandBuffer12, false);
                  console.log('Command sent using sendAsyncWithThrottle:', _command0);
                  return new Promise(function (resolve) {
                    setTimeout(function () {
                      resolve(script.callReturn());
                    }, time + 1100);
                  });
                } else {
                  console.log('Serial writer not found.');
                }
              } else {
                stick1 = stick1 * -1;
                stick2 = stick2 * -1;
                var _command1 = "back ".concat(stick1, " ").concat(time, "\r");
                console.log('Constructed command:', _command1);
                var _commandBuffer13 = Buffer.from(_command1, 'utf8');
                var _command10 = "ccw ".concat(stick2, " ").concat(time, "\r");
                console.log('Constructed command:', _command10);
                var _commandBuffer14 = Buffer.from(_command10, 'utf8');
                if (Entry.hwLite && Entry.hwLite.serial && Entry.hwLite.serial.writer) {
                  Entry.hwLite.serial.sendAsyncWithThrottle(_commandBuffer13, false);
                  console.log('Command sent using sendAsyncWithThrottle:', _command1);
                  Entry.hwLite.serial.sendAsyncWithThrottle(_commandBuffer14, false);
                  console.log('Command sent using sendAsyncWithThrottle:', _command10);
                  return new Promise(function (resolve) {
                    setTimeout(function () {
                      resolve(script.callReturn());
                    }, time + 1100);
                  });
                } else {
                  console.log('Serial writer not found.');
                }
              }
              return script.callReturn();
            }
          },
          Wizwing_Drone_Controller_photoflight: {
            color: EntryStatic.colorSet.block["default"].HARDWARE,
            outerLine: EntryStatic.colorSet.block.darken.HARDWARE,
            skeleton: 'basic',
            fontColor: '#fff',
            statements: [],
            params: [{
              type: 'Block',
              accept: 'string'
            }, {
              type: 'Block',
              accept: 'string'
            }, {
              type: 'Block',
              accept: 'string'
            }],
            def: {
              params: [null, null, null],
              type: 'Wizwing_Drone_Controller_photoflight'
            },
            paramsKeyMap: {
              STICK1: 0,
              STICK2: 1,
              TIME: 2
            },
            "class": 'wizwing',
            isNotFor: ['wizwingcontrollerlite'],
            func: function func(sprite, script) {
              var stick1 = script.getNumberValue('STICK1', script) * 5;
              var stick2 = script.getNumberValue('STICK2', script) * 5;
              var time = script.getNumberValue('TIME', script);
              if (stick1 > 500) {
                stick1 = 500;
              } else if (stick1 < -500) {
                stick1 = -500;
              }
              if (stick2 > 500) {
                stick2 = 500;
              } else if (stick2 < -500) {
                stick2 = -500;
              }
              if (stick1 >= 0 && stick2 >= 0) {
                var command1 = "right ".concat(stick1, " ").concat(time, "\r");
                console.log('Constructed command:', command1);
                var commandBuffer1 = Buffer.from(command1, 'utf8');
                var command11 = "cw ".concat(stick2, " ").concat(time, "\r");
                console.log('Constructed command:', command11);
                var commandBuffer11 = Buffer.from(command11, 'utf8');
                if (Entry.hwLite && Entry.hwLite.serial && Entry.hwLite.serial.writer) {
                  Entry.hwLite.serial.sendAsyncWithThrottle(commandBuffer1, false);
                  console.log('Command sent using sendAsyncWithThrottle:', command1);
                  Entry.hwLite.serial.sendAsyncWithThrottle(commandBuffer11, false);
                  console.log('Command sent using sendAsyncWithThrottle:', command11);
                  return new Promise(function (resolve) {
                    setTimeout(function () {
                      resolve(script.callReturn());
                    }, time + 1100);
                  });
                } else {
                  console.log('Serial writer not found.');
                }
              } else if (stick1 >= 0 && stick2 < 0) {
                stick2 = stick2 * -1;
                var _command11 = "right ".concat(stick1, " ").concat(time, "\r");
                console.log('Constructed command:', _command11);
                var _commandBuffer15 = Buffer.from(_command11, 'utf8');
                var _command12 = "ccw ".concat(stick2, " ").concat(time, "\r");
                console.log('Constructed command:', _command12);
                var _commandBuffer16 = Buffer.from(_command12, 'utf8');
                if (Entry.hwLite && Entry.hwLite.serial && Entry.hwLite.serial.writer) {
                  Entry.hwLite.serial.sendAsyncWithThrottle(_commandBuffer15, false);
                  console.log('Command sent using sendAsyncWithThrottle:', _command11);
                  Entry.hwLite.serial.sendAsyncWithThrottle(_commandBuffer16, false);
                  console.log('Command sent using sendAsyncWithThrottle:', _command12);
                  return new Promise(function (resolve) {
                    setTimeout(function () {
                      resolve(script.callReturn());
                    }, time + 1100);
                  });
                } else {
                  console.log('Serial writer not found.');
                }
              } else if (stick1 < 0 && stick2 >= 0) {
                stick1 = stick1 * -1;
                var _command13 = "left ".concat(stick1, " ").concat(time, "\r");
                console.log('Constructed command:', _command13);
                var _commandBuffer17 = Buffer.from(_command13, 'utf8');
                var _command14 = "cw ".concat(stick2, " ").concat(time, "\r");
                console.log('Constructed command:', _command14);
                var _commandBuffer18 = Buffer.from(_command14, 'utf8');
                if (Entry.hwLite && Entry.hwLite.serial && Entry.hwLite.serial.writer) {
                  Entry.hwLite.serial.sendAsyncWithThrottle(_commandBuffer17, false);
                  console.log('Command sent using sendAsyncWithThrottle:', _command13);
                  Entry.hwLite.serial.sendAsyncWithThrottle(_commandBuffer18, false);
                  console.log('Command sent using sendAsyncWithThrottle:', _command14);
                  return new Promise(function (resolve) {
                    setTimeout(function () {
                      resolve(script.callReturn());
                    }, time + 1100);
                  });
                } else {
                  console.log('Serial writer not found.');
                }
              } else {
                stick1 = stick1 * -1;
                stick2 = stick2 * -1;
                var _command15 = "left ".concat(stick1, " ").concat(time, "\r");
                console.log('Constructed command:', _command15);
                var _commandBuffer19 = Buffer.from(_command15, 'utf8');
                var _command16 = "ccw ".concat(stick2, " ").concat(time, "\r");
                console.log('Constructed command:', _command16);
                var _commandBuffer20 = Buffer.from(_command16, 'utf8');
                if (Entry.hwLite && Entry.hwLite.serial && Entry.hwLite.serial.writer) {
                  Entry.hwLite.serial.sendAsyncWithThrottle(_commandBuffer19, false);
                  console.log('Command sent using sendAsyncWithThrottle:', _command15);
                  Entry.hwLite.serial.sendAsyncWithThrottle(_commandBuffer20, false);
                  console.log('Command sent using sendAsyncWithThrottle:', _command16);
                  return new Promise(function (resolve) {
                    setTimeout(function () {
                      resolve(script.callReturn());
                    }, time + 1100);
                  });
                } else {
                  console.log('Serial writer not found.');
                }
              }
              return script.callReturn();
            }
          }
        };
      }
    }]);
  }())();
})();
module.exports = Entry.wizwingcontrollerlite;